module.exports = __webpack_public_path__ + "img/header_logo.04666075.png";